export default {
  en: {
    editSupplementRemark: 'Edit Supplement Remark',
    supplementCharge: 'Supplement Charge',
    edit: 'Save Changes',
    cancel: 'Cancel',
    updateRemarkSuccessTitle: 'Success',
    updateRemarkSuccessMessage: 'Update Room Type Remark Success.'
  },
  th: {
    editSupplementRemark: 'แก้ไขหมายเหตุ Supplement Charge',
    supplementCharge: 'Supplement Charge',
    edit: 'บันทึก',
    cancel: 'ยกเลิก',
    updateRemarkSuccessTitle: 'สำเร็จ',
    updateRemarkSuccessMessage: 'แก้ไขหมายเหตุ Supplement Charge สำเร็จ'
  }
}
